import React, { useState } from 'react';

const faqCategories = [
  { id: 'company', label: 'Company Registration', icon: 'fa-building-columns' },
  { id: 'trademark', label: 'Trademark Registration', icon: 'fa-trademark' },
  { id: 'gst', label: 'GST Registration', icon: 'fa-file-invoice-dollar' },
  { id: 'fssai', label: 'FSSAI License', icon: 'fa-utensils' },
  { id: 'iec', label: 'IEC Code', icon: 'fa-ship' },
  { id: 'iso', label: 'ISO Certification', icon: 'fa-certificate' }
];

const faqsData = {
  company: [
    {
      q: 'What is the minimum capital required to register a Private Limited Company in India?',
      a: 'There is no minimum capital requirement to start a Private Limited Company. You can register your company with as little as ₹10,000 as authorized capital.'
    },
    {
      q: 'What documents are needed for company incorporation?',
      a: 'You will need PAN Card, Aadhaar Card, Passport size photos of directors, and proof of address for the registered office (such as a utility bill, rent agreement, or NOC from the owner).'
    },
    {
      q: 'How long does the company registration process take?',
      a: 'Typically, it takes about 7 to 10 working days, subject to government processing times and document availability.'
    }
  ],
  trademark: [
    {
      q: 'What is the validity of a Trademark Registration?',
      a: 'Once registered, a trademark is valid for 10 years. It can be renewed indefinitely every 10 years before expiry by paying the government renewal fee.'
    },
    {
      q: 'Can I use the ™ symbol immediately after applying?',
      a: 'Yes, you can use the ™ symbol as soon as you receive the trademark application filing receipt. However, the ® symbol can only be used once the registration certificate is officially issued.'
    }
  ],
  gst: [
    {
      q: 'Who is required to obtain GST registration in India?',
      a: "Businesses with an annual turnover exceeding ₹40 Lakhs (₹20 Lakhs for North-Eastern and hill states) for the supply of goods, or ₹20 Lakhs (₹10 Lakhs for services), as well as any business engaged in interstate sales, must obtain GST registration."
    },
    {
      q: 'Is GST registration mandatory for e-commerce sellers?',
      a: 'Yes, GST registration is mandatory for all e-commerce operators and individuals selling goods or services through e-commerce platforms, regardless of their annual turnover.'
    }
  ],
  fssai: [
    {
      q: 'Which FSSAI License is required for my food business?',
      a: 'FSSAI food licenses are categorized into three types based on business turnover and capacity: Basic Registration (for turnover under ₹12 Lakhs), State License (turnover between ₹12 Lakhs and ₹20 Crores), and Central License (turnover exceeding ₹20 Crores or for importers).'
    },
    {
      q: 'Is an FSSAI license mandatory for home bakers or cloud kitchens?',
      a: 'Yes, any business operator involved in manufacturing, processing, packaging, storing, or distributing food—including home bakers, cloud kitchens, and small food stalls—must obtain at least a basic FSSAI registration.'
    }
  ],
  iec: [
    {
      q: 'What is an IEC (Import Export Code)?',
      a: 'An Import Export Code (IEC) is a unique 10-digit registration code issued by the Directorate General of Foreign Trade (DGFT), Ministry of Commerce, Government of India. It is mandatory for importing or exporting goods and services from/to India.'
    },
    {
      q: 'Does an IEC require regular filings or renewals?',
      a: 'No, an IEC is issued for a lifetime and does not require renewals. However, you must update your IEC details on the DGFT portal annually between April and June.'
    }
  ],
  iso: [
    {
      q: 'Which ISO certification is standard for businesses?',
      a: 'ISO 9001:2015 (Quality Management System) is the most globally recognized certification standard and is suitable for all industries. Other common standards include ISO 14001 (Environmental) and ISO 27001 (Information Security).'
    },
    {
      q: 'How does an ISO certification help my business?',
      a: 'ISO certification enhances your brand credibility, improves operational efficiency, increases customer satisfaction, and is often a mandatory requirement for bidding on government and corporate tenders.'
    }
  ]
};

const FAQ = () => {
  const [activeTab, setActiveTab] = useState('company');
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section id="faq" className="section-padding bg-white">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

        .faq-section {
          font-family: 'Inter', sans-serif;
        }

        .faq-tabs-scroll {
          overflow-x: auto;
          scrollbar-width: none; /* Firefox */
          -ms-overflow-style: none;  /* IE 10+ */
        }
        .faq-tabs-scroll::-webkit-scrollbar {
          display: none; /* Safari and Chrome */
        }

        .faq-tab-btn {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 14px 24px;
          background: #f8fafc;
          border: 1.5px solid #e2e8f0;
          border-radius: 14px;
          font-size: 14.5px;
          font-weight: 700;
          color: #475569;
          cursor: pointer;
          transition: all 0.2s ease;
          white-space: nowrap;
        }

        .faq-tab-btn:hover {
          background: #f1f5f9;
          border-color: #cbd5e1;
          color: #0f172a;
        }

        .faq-tab-btn.active {
          background: #e9f2eb;
          border-color: #061830;
          color: #061830;
        }

        .faq-accordion {
          display: flex;
          flex-direction: column;
          gap: 16px;
          max-width: 800px;
          margin: 0 auto;
        }

        .faq-item {
          border: 1.5px solid #e2e8f0;
          border-radius: 16px;
          overflow: hidden;
          background: #ffffff;
          transition: border-color 0.2s;
        }

        .faq-item.active {
          border-color: #061830;
          box-shadow: 0 4px 20px rgba(21, 71, 52, 0.04);
        }

        .faq-question-btn {
          width: 100%;
          padding: 22px 28px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: none;
          border: none;
          text-align: left;
          font-size: 16.5px;
          font-weight: 700;
          color: #0f172a;
          cursor: pointer;
          outline: none;
        }

        .faq-icon-indicator {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          background: #f1f5f9;
          color: #475569;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          transition: all 0.25s ease;
        }

        .faq-item.active .faq-icon-indicator {
          background: #061830;
          color: white;
          transform: rotate(45deg);
        }

        .faq-answer-wrap {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s cubic-bezier(0, 1, 0, 1);
        }

        .faq-item.active .faq-answer-wrap {
          max-height: 300px; /* safety limit */
          transition: max-height 0.3s cubic-bezier(1, 0, 1, 0);
        }

        .faq-answer {
          padding: 0 28px 24px;
          font-size: 14.5px;
          color: #475569;
          line-height: 1.7;
          border-top: 1px dashed #e2e8f0;
          padding-top: 18px;
        }
      `}</style>

      <div className="container faq-section">
        {/* Section Header */}
        <div className="text-center mb-5 pb-2" style={{ maxWidth: '720px', margin: '0 auto' }}>
          <div
            className="d-inline-flex align-items-center gap-2 mb-3 px-4 py-2 rounded-pill shadow-sm"
            style={{
              background: '#fff',
              border: '1px solid #e8edf3',
              fontSize: '12px',
              fontWeight: 700,
              letterSpacing: '1.2px',
              textTransform: 'uppercase',
              color: '#061830'
            }}
          >
            <span style={{ width: 8, height: 8, background: '#10b981', borderRadius: '50%', boxShadow: '0 0 8px #10b981' }}></span>
            Support Center
          </div>
          
          <h2 className="display-5 fw-bold mb-4" style={{ color: '#0f172a', letterSpacing: '-1.5px' }}>
            Frequently Asked <span style={{ color: '#061830' }}>Questions</span>
          </h2>
          
          <p className="text-muted" style={{ fontSize: '16px', lineHeight: 1.8 }}>
            Find answers to commonly asked questions about business incorporation, trademarking, licensing, and certifications.
          </p>
        </div>

        {/* Tab Controls */}
        <div className="faq-tabs-scroll d-flex justify-content-start justify-content-md-center gap-3 mb-5 pb-3">
          {faqCategories.map((cat) => (
            <button
              key={cat.id}
              className={`faq-tab-btn ${activeTab === cat.id ? 'active' : ''}`}
              onClick={() => {
                setActiveTab(cat.id);
                setOpenIndex(0); // auto-open first item on tab switch
              }}
            >
              <i className={`fa-solid ${cat.icon}`}></i>
              {cat.label}
            </button>
          ))}
        </div>

        {/* Accordions */}
        <div className="faq-accordion">
          {faqsData[activeTab].map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? 'active' : ''}`}
            >
              <button
                className="faq-question-btn"
                onClick={() => toggleAccordion(index)}
              >
                <span>{faq.q}</span>
                <span className="faq-icon-indicator">
                  <i className="fa-solid fa-plus"></i>
                </span>
              </button>
              
              <div className="faq-answer-wrap">
                <div className="faq-answer">
                  {faq.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
